import React, { Component } from 'react';
import { Avatar, Grid, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

const styles = (theme) => ({
  reviewOuter: {
    width: '100%',
    /*
    ['@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)']: {
      maxWidth: '70vw',
    },
    */
  },
});

class ReviewItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTimeFormat(param) {
    let d = new Date(Number(param));
    return moment(d).format('YYYY-MM-DD');
  }

  onClickItem(data) {
    if (this.props.callBackClickItem) {
      this.props.callBackClickItem(data);
    }
  }

  componentDidMount() {}

  render() {
    const { data, classes } = this.props;

    return (
      <div
        style={{ width: '100%' }}
        onClick={() => {
          this.onClickItem(data);
        }}
      >
        <Grid style={{ backgroundColor: '#fff', width: '100%' }} className={classes.reviewOuter}>
          <Grid
            container
            id="title_grid"
            style={window.matchMedia('(min-width: 960px)').matches ? { padding: '2vh 0.5vw' } : { padding: '2vh 2vw' }}
          >
            <Grid item xs={3} sm={2}>
              <Avatar alt="avatar" src={data.user.img ? data.user.img : '/images/icon/ico_user.png'} />
            </Grid>
            <Grid container alignContent="center" item xs={5} sm={6}>
              <b style={{ color: '#555555' }}>{data.user.name}</b>
            </Grid>
            <Grid container alignContent="center" justify="flex-end" item xs={4}>
              <b style={{ color: '#909090', textAlign: 'end' }}>{this.getTimeFormat(data.createdAt)}</b>
            </Grid>
          </Grid>
          <Grid container justify="center" alignItems="center" style={{ height: '200px', overflow: 'hidden' }}>
            {data.img ? (
              <img src={data.img} alt={'address'} style={{ width: '100%' }} />
            ) : (
              <div
                style={{
                  background: '#efefef',
                  height: '150px',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img alt="이미지가 없습니다." src="/images/icon/img_empty.png" style={{ height: '50px' }} />
              </div>
            )}
          </Grid>
          <Grid container style={{ padding: '20px', height: '200px' }}>
            {data.content}
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(ReviewItem));
